'use client';
import React, { createContext, useContext, useEffect, useState } from 'react';

interface SiteSettings {
  phoneNumber: string;
  showPhoneNumber: boolean;
}

const defaultSettings: SiteSettings = {
  phoneNumber: '+1 425-981-5705',
  showPhoneNumber: false,
};

const SiteSettingsContext = createContext<SiteSettings>(defaultSettings);

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}

export default function SiteSettingsProvider({ children }: { children: React.ReactNode }) {
  const [settings, setSettings] = useState<SiteSettings>(defaultSettings);

  useEffect(() => {
    fetch('/api/settings')
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          setSettings({
            phoneNumber: data.data.phoneNumber,
            showPhoneNumber: data.data.showPhoneNumber,
          });
        }
      })
      .catch((err) => console.error('Failed to load site settings', err));
  }, []);

  return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
}
